<template lang="html">
  <div>
    <Navbar></Navbar>
    <Maincontent></Maincontent>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'
import Maincontent from '@/components/Maincontent'
export default {
  components: {
    Navbar,
    Maincontent
  },
  created () {
    this.$store.commit('getTodos')
  }
}
</script>

<style lang="css">
.cardhead {
  background-color: #7FFFD4 !important;
  color: black;
  font-size: 24px;
}

.cardcontent {
  color: black;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// Page.vue?25bd9d9a